import React, { useState } from "react";
import { Box, Typography, Collapse } from "@mui/material";

// Renders a client-side (webapp navigation) tool call inline in the
// conversation, like a message — the filters the model sent to e.g.
// navigate_to_company_search, and the result count/sample (or error) it got
// back, before the model's own reply. MCP tools aren't shown here: those are
// resolved entirely inside Anthropic's connector, so we only ever see a
// short status label for them, never their actual input/output.
function formatJson(value) {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      return value;
    }
  }
  return JSON.stringify(value, null, 2);
}

const codeBoxStyles = {
  m: 0,
  p: 0.75,
  backgroundColor: "rgba(0,0,0,0.04)",
  borderRadius: 1,
  overflowX: "auto",
  fontFamily: "monospace",
  fontSize: "0.7rem",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};

function AgentChatToolCall({ toolCall }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "90%",
        border: "1px solid",
        borderColor: toolCall.isError ? "#f0b8b8" : "#dbe3f0",
        backgroundColor: toolCall.isError ? "#fdf2f2" : "#f2f5fb",
        borderRadius: 2,
        px: 1.25,
        py: 0.75,
      }}
    >
      <Box
        onClick={() => setExpanded((v) => !v)}
        sx={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 700, color: toolCall.isError ? "#b3261e" : "#33475b" }}
        >
          {expanded ? "▾" : "▸"} {toolCall.name}
          {toolCall.isError ? " — error" : ""}
        </Typography>
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ mt: 0.5 }}>
          <Typography variant="caption" sx={{ fontWeight: 600, display: "block", color: "#666" }}>
            Input
          </Typography>
          <Box component="pre" sx={{ ...codeBoxStyles, mb: 0.75 }}>
            {formatJson(toolCall.input)}
          </Box>
          <Typography variant="caption" sx={{ fontWeight: 600, display: "block", color: "#666" }}>
            Output
          </Typography>
          <Box component="pre" sx={codeBoxStyles}>
            {formatJson(toolCall.output)}
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}

export default AgentChatToolCall;
